(function () {
  'use strict';

  angular
    .module('secure3d')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('secure3d', {
        url: '/secure3d',
        templateUrl: 'secure3d/secure3d.tpl.html',
        controller: 'Secure3dCtrl',
        controllerAs: 'secure3d',
        resolve:{
          authenticationGuard: function ($rootScope, $q, $state) {
            var country = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
            if(country !== 'hr'){
              $state.go('dashboard');
              return $q.reject('Forbidden');
            }
          }
        }
      });
  }
}());
